import Logger from '../util/Logger';
import { popinApi } from './api';

export const commentApi = {

  getComments: (ideaId) => {
    return Promise.resolve().then(() => {
      if (!ideaId) {
        Logger.info('reject getComments()');
        throw Error('Must pass an ideaId');
      } else {
        return popinApi.get(`/comments/list?idea_id=${ideaId}`);
      }
    });
  },

  archive: (commentId) => {
    return Promise.resolve().then(() => {
      if (!commentId) {
        Logger.info('reject archive()');
        throw Error('Must pass an commentId');
      } else {
        return popinApi.del(`/comments/delete/${commentId}`);
      }
    });
  }
};
